import { bungeeAffiliateCode } from '@cowprotocol/common-const'
import { isDev, isProd, isStaging } from '@cowprotocol/common-utils'
import {
  AcrossBridgeProvider,
  BridgingSdk,
  BungeeBridgeProvider,
  NearIntentsBridgeProvider,
} from '@cowprotocol/sdk-bridging'

import { orderBookApi } from 'cowSdk'

import { tradingSdk } from './tradingSdk'

const bungeeApiBase = getBungeeApiBase()

const bungeeIncludeBridgesOverride = localStorage.getItem('bungeeIncludeBridges')

export const bungeeBridgeProvider = new BungeeBridgeProvider({
  apiOptions: {
    includeBridges: bungeeIncludeBridgesOverride
      ? JSON.parse(bungeeIncludeBridgesOverride)
      : ['across', 'cctp-v2-fast', 'cctp-v2', 'gnosis-native-bridge'],
    apiBaseUrl: bungeeApiBase ? `${bungeeApiBase}/api/v1/bungee` : undefined,
    manualApiBaseUrl: bungeeApiBase ? `${bungeeApiBase}/api/v1/bungee-manual` : undefined,
    affiliate: bungeeApiBase ? bungeeAffiliateCode : undefined,
  },
})

export const acrossBridgeProvider = new AcrossBridgeProvider()

export const nearIntentsBridgeProvider = new NearIntentsBridgeProvider({ apiKey: process.env.REACT_APP_NEAR_API_KEY })

export const bridgingSdk = new BridgingSdk({
  providers: [bungeeBridgeProvider, acrossBridgeProvider, nearIntentsBridgeProvider],
  enableLogging: !!localStorage.getItem('enableBridgingSdkLogs'),
  tradingSdk,
  orderBookApi,
})

// Enable only Bungee by default
bridgingSdk.setAvailableProviders([bungeeBridgeProvider.info.dappId])

function getBungeeApiBase(): string | undefined {
  if (isProd || isDev || isStaging) {
    return 'https://backend.bungee.exchange'
  }

  return 'https://bff.barn.cow.fi/proxies/socket'
}
